import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-page-title',
  standalone: true,
  imports: [],
  template: `
    <div class="page-title-container" [class.centered]="centered()">
      <h1 class="page-title">{{ title() }}</h1>
      @if (subtitle()) {
      <p class="page-subtitle">{{ subtitle() }}</p>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .page-title-container {
        margin-bottom: 1.5rem;
      }

      .page-title-container.centered {
        text-align: center;
      }

      .page-title {
        font-size: 2.2rem;
        font-weight: 500;
        margin: 0 0 0.5rem 0;
        color: var(--mat-card-title-text-color);
        letter-spacing: -0.01em;
      }

      .page-subtitle {
        font-size: 1rem;
        color: var(--mat-card-subtitle-text-color);
        margin: 0;
        padding: 0.5rem 0 1rem 0;
        font-weight: 400;
      }


      @media (max-width: 48rem) {
        .page-title {
          font-size: 1.8rem;
        }

        .page-subtitle {
          font-size: 0.9rem;
        }
      }
    `,
  ],
})
export class PageTitleComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  centered = input<boolean>(true);
}
